const state = () => ({
  message: '',
  isToast: false,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  SET_MESSAGE(state, payload) {
    state.message = payload
  },
  SET_TOAST(state, payload) {
    state.isToast = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
